import { Select } from 'antd'
import { isArray } from 'lodash-es'

/**
 * 遍历生成 Option
 */
export default function arrToListOption(arr:any[] = [], { value = 'text', title = 'title' } = {}) {
  if (!isArray(arr)) return null;
  return arr.map((item, index) => (
    <Select.Option key={index + value} value={item[value]} data={item}>
      {item[title]}
    </Select.Option>
  ))
}
